export const columnBaseTable = [
    {
        Header: 'LEDGER CODE',
        accessor : 'ledgerCode',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 50,
            width: 250, 
        }
    },
    {
        Header: 'LEDGER NAME',
        accessor : 'ledgerName',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 250,
            width: 250, 
        }
    },
    {
        Header: 'Period Ending Balance',
        accessor : 'periodEndingBalance',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 150,
            width: 250, 
        }
    },
    {
        Header: 'Period Beginning Balance',
        accessor : 'periodBeginingBalance',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 150,
            width: 250, 
        }
    },
    // {
    //     Header: 'Amount In',
    //     accessor : 'amountIn',
    //     Style:{
    //         textTransform:"uppercase",
    //         maxWidth: 400,
    //         minWidth: 150,
    //         width: 250, 
    //     }
    // }
]

export const columnDeletedLedgerBaseTable = [
    {
        Header: 'LEDGER CODE',
        accessor : 'ledgerCode',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 50,
            width: 250, 
        }
    },
    {
        Header: 'LEDGER NAME',
        accessor : 'ledgerName',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 250,
            width: 250, 
        }
    },
    {
        Header: 'Period Beginning Balance',
        accessor : 'periodBeginingBalance',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 150,
            width: 250, 
        }
    },
    {
        Header: 'Period Ending Balance',
        accessor : 'periodEndingBalance',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 150,
            width: 250, 
        }
    }
]

export const conventionalTable = [
    {
        Header: 'LEDGER CODE',
        accessor : 'ledgerCode',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 150,
            width: 250, 
        }
    },
    {
        Header: 'LEDGER NAME',
        accessor : 'ledgerName',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 200,
            width: 250, 
        }
    },
    {
        Header: 'Period Ending Balance',
        accessor : 'periodEndingBalance',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 200,
            width: 250, 
        }
    },
    {
        Header: 'Period Beginning Balance',
        accessor : 'periodBeginingBalance',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 220,
            width: 250, 
        }
    },
    {
        Header: 'FS GROUPING (CY)',
        accessor : 'fs_grp_cy',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 200,
            width: 250, 
        } 
    },
    {
        Header: 'NOTES GROUPING (CY)',
        accessor : 'note_grp_cy',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 200,
            width: 250, 
        }
    },
    {
        Header: 'SUB GROUPING (CY)',
        accessor : 'sub_grp_cy',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 200,
            width: 250, 
        } 
    },
    {
        Header: 'FS GROUPING (PY)',
        accessor : 'fs_grp_py',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 200,
            width: 250, 
        }
    },
    {
        Header: 'NOTES GROUPING (PY)',
        accessor : 'note_grp_py',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 200,
            width: 250, 
        }
    },
    {
        Header: 'SUB GROUPING (PY)',
        accessor : 'sub_grp_py',
        Style:{
            textTransform:"uppercase",
            maxWidth: 400,
            minWidth: 200,
            width: 250, 
        }
    },

]